import styled, { css } from 'styled-components'
import { tabletBreakpoint, theme } from 'react-components'

export const WhyBookThisHomeWrapper = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex: 1;
    flex-direction: ${({ theme }) => theme.style.flexDirection.column};
`

export const WhyBookThisHomeContentContainer = styled.div`
    display: flex;
    flex-direction: column;
`

export const WhyBookThisHomeItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.small};
    padding: 0.5rem 0;
`

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    padding-top: 0.4rem;

    svg {
        width: 1.5rem;
        height: 1.5rem;
    }
`

export const ItemContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.3125rem;
    flex: 1;
`

export const ItemTitle = styled.div`
    font-family: ${theme.typography.font.family.lato};
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.375rem;
    letter-spacing: 0px;
`

export const ItemDescription = styled.div`
    font-family: ${theme.typography.font.family.lato};
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.375rem;
    letter-spacing: 0px;
    color: #6f6f6f;
`

export const AITagWrapper = styled.div`
    font-family: ${theme.typography.font.family.lato};
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1rem;
    color: #6b43a4;
    background-color: #f9f5ff;
    letter-spacing: 0px;
    width: fit-content;
    border-radius: 0.25rem;
    margin-bottom: -0.5rem;
    margin-top: 0.625rem;
    padding: 0.2rem 0.3rem;
`
